// extracted by mini-css-extract-plugin
module.exports = {"SignUp":"SignUp_SignUp__2XwrQ","ButtonContainer":"SignUp_ButtonContainer__1vgG4","Or":"SignUp_Or__2b7xn","Link":"SignUp_Link__2kMyP"};